import { useAtom } from 'jotai';
import { onboardingAccountDataAtom } from '@ibk/shared-utils';
export function useAccountData() {
    const [accountData, setAccountData] = useAtom(onboardingAccountDataAtom);
    const setCpf = (cpf) => {
        setAccountData(prev => ({ ...prev, cpf }));
    };
    const setAccount = (account) => {
        setAccountData(prev => ({ ...prev, accountData: account }));
    };
    const setDeviceId = (deviceId) => {
        setAccountData(prev => ({ ...prev, deviceId }));
    };
    const setFullName = (fullName) => {
        setAccountData(prev => ({ ...prev, fullName }));
    };
    const setEmail = (email) => {
        setAccountData(prev => (prev.accountData ? { ...prev, accountData: { ...prev.accountData, email } } : prev));
    };
    const setPhone = (phoneNumber) => {
        setAccountData(prev => (prev.accountData ? { ...prev, accountData: { ...prev.accountData, phoneNumber } } : prev));
    };
    const setPassword = (password) => {
        setAccountData(prev => ({ ...prev, password }));
    };
    const setMaskedRecipient = (maskedRecipient) => {
        setAccountData(prev => ({ ...prev, maskedRecipient }));
    };
    const clearData = () => {
        setAccountData({
            cpf: '',
            accountData: null,
            deviceId: null,
            fullName: '',
            password: '',
            maskedRecipient: null,
        });
    };
    return {
        cpf: accountData.cpf,
        accountData: accountData.accountData,
        email: accountData.accountData?.email ?? '',
        phone: accountData.accountData?.phoneNumber ?? '',
        onboardingContactToken: accountData.accountData?.onboarding_contact_token ?? null,
        deviceId: accountData.deviceId,
        fullName: accountData.fullName,
        password: accountData.password,
        maskedRecipient: accountData.maskedRecipient ?? null,
        setCpf,
        setAccount,
        setDeviceId,
        setFullName,
        setEmail,
        setPhone,
        setPassword,
        setMaskedRecipient,
        clearData,
    };
}
